import { useAuth } from '@/services/auth';
import { AppRoutes } from '@/utils/types';
import { isAndroid, isIOS } from '@/utils/utils';
import { useNavigate } from 'react-router-dom';

const bypassPaths = [
    AppRoutes.PostSso,
    AppRoutes.Share,
    AppRoutes.PostCheckout,
    AppRoutes.Docs,
    AppRoutes.AgentShare,
    AppRoutes.Friends,
    AppRoutes.Checkout,
    AppRoutes.CampaignLandingPage,
    AppRoutes.MobileHomepage,
];
const skipRedirectFlag = 'skip_mobile_redirect';

interface Props {
    children?: React.ReactNode;
}

export const MobileRouter = ({ children }: Props) => {
    const navigate = useNavigate();
    const { isAnonymous, loginWithRedirect } = useAuth();

    const skipRedirect =
        bypassPaths.some(path => window.location.pathname.startsWith(path)) || window.location.href.includes(skipRedirectFlag);

    const isAndroidDevice = isAndroid();
    const isIosDevice = isIOS();

    if (!skipRedirect && (isAndroidDevice || isIosDevice)) {
        if (isAnonymous) {
            loginWithRedirect({ screen_hint: 'signup' });
        } else {
            navigate(AppRoutes.MobileHomepage);
        }
        return <></>;
    }

    return <>{children}</>;
};
